//  Molto in progress...
import React from 'react';
import {PropTypes} from 'prop-types';

class Notification extends React.Component {
  constructor() {
    super();
    //
    this.defaultTimeout = 5000;
    this.messageNodes = {}; //  mappa msgId => nodo HTML del messaggio
    //
    this.state = {
      messages: [],

    };
  }

  /**
   * Do not call directly
   * 
  */
  addMessage = (type, message, source, autoClose, closeButton) => {
    //
    const newMessage = {msgId: guid(), type, message, source, closeButton};
    //
    if(source == 'default') {
      //  aggiungo messaggio
      this.setState((prevState) => {
        return {
          messages: [...prevState.messages, newMessage]
        };
      });
    } else {
      //  stesso src: sovrascrivo messaggio
      this.setState((prevState) => {
        return {
          messages: [...prevState.messages.filter(o => o.source != source), newMessage]
        };
      });
    }
    //
    if (autoClose) {
      const timer = setTimeout(() => {
        this.removeMessage(newMessage.msgId);
      }, this.defaultTimeout);
    }

  }

  addInfo = (message, source='default', autoClose=true, closeButton=false) => {
    this.addMessage('info', message, source, autoClose, closeButton);
  }

  /**
   * @param {string} message
   * @param {string} source
   * @param {boolean} autoClose
   * @param {boolean} closeButton
   * 
   */
  addSuccess = (message, source='default', autoClose=true, closeButton=false) => {
    this.addMessage('success', message, source, autoClose, closeButton);
  }

  addWarning = (message, source='default', autoClose=true, closeButton=false) => {
    this.addMessage('warning', message, source, autoClose, closeButton);
  }

  
  addError = (message, source='default', autoClose=true, closeButton=false) => {
    this.addMessage('error', message, source, autoClose, closeButton);
  }

  removeMessage = (msgId) => {
    const node = this.messageNodes[msgId];
    if (node) {
      node.classList.add("closing");
      delete this.messageNodes[msgId];
    }

    setTimeout(() => {
      this.setState((prevState) => {
        return {
          messages: [...prevState.messages.filter(o => o.msgId != msgId)]
        };
      });
    }, 1000);
  }

  addMessageRef = (node) => {
    if (node && node.getAttribute('data-msgid')) {
      this.messageNodes[node.getAttribute('data-msgid')] = node;
    }
  }

  onCloseClick = (event) => {
    event.preventDefault();
    this.removeMessage(event.target.getAttribute('data-msgid'));
  }

  renderMessage = (o, idx) => {
    return(
      <div key={idx} className={`message-feedback is-` + o.type} data-msgid={o.msgId} ref={this.addMessageRef}>
        <span className="message-feedback_icon"/>
        {o.message}
        {` `}
        {o.closeButton && <a className="message-feedback_close" href="" data-msgid={o.msgId} onClick={this.onCloseClick}/>}
      </div>
    );
  }

  render() {
    return(
      <div className="message-feedback_container">
      {this.state.messages.map((o, idx) => this.renderMessage(o,idx))}
      </div>
    );
  }

}

function guid() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}


export default Notification;